/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import {
	store
} from '@/store/store'
import {
	customerApi
} from '@/services/ApiServices/customerApi'
import {
	cartApis
} from '@/services/ApiServices/cartApis'
import url from '@/services/ApiServices/apiUrls'
import router from '@/router/index'
import {
	vendorApis
} from './vendorApis'
import {
	globalApis
} from './globalApis'
import { agentApis } from './agentApis'

export const authenticationApi = new Vue({
	methods: {
		login (userData, redirection = 'login') {
			return new Promise((resolve, reject) => {
				if (store.getters['agent/isAgentAuthenticated']) {
					agentApis.agentLogOut()
				} else if (store.getters['vendor/isVendorAuthenticated']) {
					vendorApis.vendorLogOut()
				}
				this.$http.post(url.login, userData)
					.then((res) => {
						if (redirection === 'login') {
							// Vue.toasted.success('You are Successfully Logged in.', { position: 'top-center' });
						}
						if (res.status === 200) {
							cartApis.getCart().then(() => {
								if (store.getters['cart/getOrderCart'].length > 0) {
									cartApis.updateCart().then(() => {
										cartApis.insertCart()
									})
								}
							})
							// customerApi.getRecentlyViewedProducts()
							customerApi.getWishList()
							customerApi.getAddresses()
						}
						customerApi.getCustomerDetails()
						globalApis.deliveryAddressCountryChooser()
						store.dispatch('user/setLoginStatus', true)
						resolve(res)
					}).catch((e) => {
						if (e.status === 404) {
							Vue.toasted.show(' You are not registered with us. Please sign up. ', {
								theme: 'toasted-primary',
								position: 'top-right'
							})
						} else if (e.status === 403) {
							/* todo : fix this commented code and remove error toast */
							// Vue.validator.errors.add({
							//   field: 'email',
							//   msg: 'Your username or password is incorrect',
							//   rule: 'email', // optional
							// });
							Vue.toasted.show(' Your username or password is incorrect.', {
								icon: 'exclamation-circle'
							})
						} else {
							Vue.toasted.show(' Whoops ! something went wrong. Please try again later. ', {
								icon: 'exclamation-circle'
							})
						}
						reject(e)
					})
			})
		},
		signUp (userData) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.signUp, userData)
					.then((res) => {
						customerApi.getCustomerDetails()
						globalApis.deliveryAddressCountryChooser()
						if (res.data.status === 409) {
							Vue.toasted.show(' Already Registered! Please Login. ', {
								icon: 'exclamation-circle'
							})
						} else if (res.status === 201) {
							// Vue.toasted.success('You have successfully registered and
							// logged in.', { position: 'top-center' });
						}
						store.dispatch('user/setLoginStatus', true)
						resolve(res)
					})
					.catch((e) => {
						/* todo : fix the comment code to replace following error toast */
						// Vue.validator.errors.add({
						//   field: 'email',
						//   msg: e.body.message,
						//   rule: 'email', // optional
						// });
						if (e.data.status === 409) {
							Vue.toasted.show(' Already Registered! Please Login. ', {
								icon: 'exclamation-circle'
							})
						} else {
							Vue.toasted.show(`${e.body.message}`, {
								icon: 'exclamation-circle'
							})
						}
						reject(e)
					})
			})
		},
		userVerification (email) {
			return new Promise((resolve, reject) => {
				const a = {
					email
				}
				this.$http.post(url.userVerificationUrl, a)
					.then((res) => {
						if (res.status === 200) {}
						resolve(res)
					})
					.catch((e) => {
						if (e.status === 406) {
							Vue.toasted.error(' Already Registered! Please Login. ', {
								icon: 'exclamation-circle'
							})
						}
						reject(e)
					})
			})
		},
		sendOTP (phone) {
			return new Promise((resolve, reject) => {
				this.$http.get(url.sendOTP + phone)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show(' An error occurred while sending otp. Try Again! ', {
							icon: 'exclamation-circle'
						})
						reject(e)
					})
			})
		},
		sendOTPEmail (email) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.sendOTPEmail, {
					email
				})
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						Vue.toasted.show(' An error occurred while sending otp. Try Again! ', {
							icon: 'exclamation-circle'
						})
						reject(e)
					})
			})
		},
		verifyOTP (otp) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.verifyOTP + otp)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						if (e.data.status === 403) {
							Vue.toasted.show('OTP verification failed ! Invalid OTP.')
						} else {
							Vue.toasted.show('OTP verification failed ! Please try again later.')
						}
						reject(e)
					})
			})
		},
		verifyOTPEmail (otp) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.verifyOTPEmail + otp)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						if (e.data.status === 403) {
							Vue.toasted.show('OTP verification failed ! Invalid OTP.')
						} else {
							Vue.toasted.show('OTP verification failed ! Please try again later.')
						}
						reject(e)
					})
			})
		},
		logOut () {
			return new Promise((resolve, reject) => {
				// if (store.getters['cart/getOrderCart'].length > 0 &&
				// router.currentRoute.path !== '/order-success') {
				//   // cartApis.insertCart();
				// } else {
				//   cartApis.clearCart();
				// }
				customerApi.insertWishList()
				this.$http.get(url.signOut)
					.then((res) => {
						store.dispatch('user/clearUserData')
						store.dispatch('user/clearAddressData')
						store.dispatch('recentview/clearRecentProductsData')
						store.dispatch('wishlist/emptyWishlist')
						store.dispatch('cart/emptyCart')
						store.dispatch('home/clearRecommendProductsData')
						if (router.currentRoute.matched.some(record => record.meta.requiresAuth)) {
							router.push({
								name: 'Home'
							})
						}
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		forgotPassword (userData) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.forgotPasswordUrl, userData)
					.then((res) => {
						if (res.status === 200) {
							store.dispatch('user/clearUserData')
							store.dispatch('wishlist/emptyWishlist')
							resolve(res)
							// router.push({
							//   name: 'Home',
							// });
						} else {
							Vue.toasted.show(' Password reset request failed Please try again later. ', {
								icon: 'exclamation-circle'
							})
						}
					})
					.catch((e) => {
						if (e.status === 403) {
							Vue.toasted.show('Existing Password', {
								icon: 'exclamation-circle'
							})
						} else {
							Vue.toasted.show('Password Reset Failed', {
								icon: 'exclamation-circle'
							})
						}
						reject(e)
					})
			})
		},
		resetPassword (userData) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.resetPassword, userData)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						if (e.status === 403) {
							Vue.toasted.show('Existing Password', {
								icon: 'exclamation-circle'
							})
						} else {
							Vue.toasted.show('Password Reset Failed', {
								icon: 'exclamation-circle'
							})
						}
						reject(e)
					})
			})
		},
		updatePassword (userData) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.updatePassword, userData)
					.then((res) => {
						store.dispatch('user/clearUserData')
						store.dispatch('wishlist/emptyWishlist')
						resolve(res)
						router.push({
							name: 'Home'
						})
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		async verifyClient (userData) {
			try {
				const response = await this.$http.post(url.verifyClientUrl, userData)
				return response.data
			} catch (err) {
				throw err
			}
		},
		bankAccountLoginOtpSend (accountNumber = '', cardNumber = '', password = '', accountData) {
			if (store.getters['vendor/isVendorAuthenticated'] === true) {
				vendorApis.vendorLogOut()
			}
			return new Promise((resolve, reject) => {
				this.$http.post(url.bankAccountLoginOtpSendUrl, {
					account_number: accountNumber,
					card_number: cardNumber,
					password: password,
					income_slab: accountData.income_slab,
					occupation: accountData.occupation,
					dob: accountData.dob
				}).then((res) => {
					resolve(res)
				}).catch((err) => {
					Vue.toasted.show(err.data.message, {
						theme: 'toasted-primary',
						position: 'top-right'
					})
					reject(err)
				})
			})
		},
		tenantRegistration (accountNumber = '') {
			if (store.getters['vendor/isVendorAuthenticated'] === true) {
				vendorApis.vendorLogOut()
			}
			return new Promise((resolve, reject) => {
				this.$http.post(url.tenantRegistrationUrl, {
					account_number: accountNumber
				}).then((res) => {
					resolve(res)
				}).catch((err) => {
					// Vue.toasted.show(err.data.message, {
					// 	theme: 'toasted-primary',
					// 	position: 'top-right'
					// })
					reject(err)
				})
			})
		},
		bankAccountLoginOtpVerify (otp) {
			return new Promise((resolve, reject) => {
				this.$http.post(url.bankAccountLoginOtpVerifyUrl, {
					otp: otp
				}).then((res) => {
					if (res.status === 200) {
						cartApis.getCart().then(() => {
							if (store.getters['cart/getOrderCart'].length > 0) {
								cartApis.updateCart().then(() => {
									cartApis.insertCart()
								})
							}
						})
						// customerApi.getRecentlyViewedProducts()
						customerApi.getWishList()
						customerApi.getAddresses()
					}
					customerApi.getCustomerDetails()
					globalApis.deliveryAddressCountryChooser()
					store.dispatch('user/setLoginStatus', true)
					resolve(res)
				}).catch((err) => {
					Vue.toasted.show(err.data.message, {
						theme: 'toasted-primary',
						position: 'top-right'
					})
					reject(err)
				})
			})
		}
	}
})
